import React, { ReactChild, ReactNode } from 'react';
import styled from 'styled-components';
import { colors } from 'constants/colors';
import { shadows } from 'constants/shadows';
import { Box, Flex } from '@igooods/ui-kit';
import CustomScrollbar from './CustomScrollbar';

interface IScrollbarDropdown {
  py?: number;
  px?: number;
  maxHeight?: number;
  minHeight?: number;
  children: ReactNode | ReactChild;
  testId?: string;
  className?: string;
}

const Container = styled(Box).attrs({ px: 1 })`
  position: absolute;
  z-index: -1;
  width: 100%;
  border-radius: 24px;
  box-shadow: ${shadows.boxShadow};
  top: calc(100% + 10px);
  background-color: ${colors.white};
`;

const ScrollbarDropdown: React.FC<IScrollbarDropdown> = ({
  py = 6.5,
  px = 5.5,
  maxHeight = 236,
  minHeight = 80,
  children,
  testId,
  className,
}) => {
  return (
    <Container className={className} data-testid={testId}>
      <CustomScrollbar maxHeight={maxHeight} minHeight={minHeight}>
        <Flex column px={px} pt={py}>
          {children}
        </Flex>
      </CustomScrollbar>
    </Container>
  );
};

export default ScrollbarDropdown;
